import React, { Component } from 'react';
import { Thumbnail, Col, Button, Row, Panel, FormGroup, InputGroup, FormControl } from 'react-bootstrap'
import { connect } from 'react-redux'

import NavHeader from './navheader'
import { updateCartProducts, FETCH_PROMOTION_PRODUCTS } from '../actions'
import { getMoneyFormat } from '../utils'

class OrderReviewProductCard extends Component {

    onAmountChange(value, product_id) {
        let decimal = (value % 1).toFixed(12)
        decimal = String(Number(decimal))
        let decimal_count = 0
        for (var i = 2; i < decimal.length; i++) {
            decimal_count += 1
        }

        let products = JSON.parse(localStorage.getItem('cart_products'))
        if ((value >= 0 || value == '') && decimal_count < 2) {
            products[product_id]['product_amount'] = value
            this.props.updateCartProducts(products)
        }
    }

    onProductDescriptionChange(value, product_id) {
        let products = JSON.parse(localStorage.getItem('cart_products'))
        products[product_id]['product_description'] = value
        this.props.updateCartProducts(products)
    }

    onIncreaseAmount(product_id) {
        let products = JSON.parse(localStorage.getItem('cart_products'))
        let step = this.props.product_unit == 'กิโลกรัม' ? 0.1 : 1
        products[product_id]['product_amount'] = Number((products[product_id]['product_amount'] + step).toFixed(1))
        this.props.updateCartProducts(products)
    }
    onDecreaseAmount(product_id) {
        let products = JSON.parse(localStorage.getItem('cart_products'))
        let step = this.props.product_unit == 'กิโลกรัม' ? 0.1 : 1
        if (products[product_id]['product_amount'] - step > 0) {
            products[product_id]['product_amount'] = Number((products[product_id]['product_amount'] - step).toFixed(1))
            this.props.updateCartProducts(products)
        }
    }

    render() {
        let product_id = this.props.product_id
        let product_name = this.props.product_name
        let product_price_unit = this.props.product_price_unit
        let product_amount = this.props.product_amount
        let product_price = product_price_unit * product_amount
        let product_image_url = this.props.product_image_url
        let product_description = this.props.product_description
        let product_unit = this.props.product_unit

        return (
            // <tr>
            //     <td style={{ textAlign: 'center' }}><div className='col-md-3 col-xs-12 col-sm-4' style={{ padding: 0 }}><image src={product_image_url} style={{ width: '100% !important' }} /></div><div className='col-md-9 col-xs-12 col-sm-8'><h5 style={{ textAlign: 'left' }}>{product_name}</h5></div></td>
            //     <td style={{ textAlign: 'center' }}><h5 style={{ textAlign: 'center' }}>{getMoneyFormat(product_price_unit.toFixed(2))}</h5></td>
            //     <td style={{ textAlign: 'center' }}><input className="form-control" value={product_amount} style={{ width: 80 }}
            //         onChange={e => this.onAmountChange(e.target.value, product_id)} placeholder={'จำนวน'} type='number'
            //         onBlur={() => {
            //             product_amount == '' || product_amount == 0 ?
            //                 this.props.setOrderReviewPageState({ showModal: true, product_name: product_name, product_id: product_id })
            //                 : ''
            //         }}
            //     /></td>
            //     <td style={{ textAlign: 'center' }}><h5 style={{ textAlign: 'center' }}>{product_unit}</h5></td>
            //     <td style={{ textAlign: 'center' }}><h5 style={{ textAlign: 'center' }}>{getMoneyFormat(product_price.toFixed(2))}</h5></td>
            //     <td><input className='form-control' placeholder='กรอกความต้องการเพิ่มเติม'
            //         onChange={e => this.onProductDescriptionChange(e.target.value, product_id)} value={product_description}
            //     ></input></td>
            //     <td style={{ textAlign: 'center' }}><Button bsStyle='danger' onClick={() => {
            //         let newState = { showModal: true, product_name: product_name, product_id: product_id }
            //         this.props.setOrderReviewPageState({ ...newState })
            //     }}>ลบ</Button></td>
            // </tr>
            <Panel style={{ margin: 5 }} >
                <Row style={{ padding: 0, paddingBottom: 10 }}>
                    <Col xs={12} sm={6} md={6} lg={6} style={{ padding: 0 }}>
                        <Row style={{ padding: 0 }}>
                            <Col xs={0} sm={2} md={2} lg={2} style={{ padding: 0 }}>
                            </Col>
                            <Col xs={12} sm={8} md={8} lg={8} style={{ padding: 0 }}>
                                <div>
                                    <h5 style={{ textAlign: 'center' }}>{product_name}</h5>
                                    <image src={product_image_url} style={{ width: '100% !important' }} />
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} sm={6} md={6} lg={6} style={{ padding: 0 }}>
                        <Row style={{ padding: 0 }}>
                            <Col xs={12} sm={12} md={12} lg={12} style={{ padding: 0 }}>
                                <h5 style={{ textAlign: 'center', color: '#898989' }}>ราคา <strong>{product_price_unit}</strong> บาท/ {product_unit}</h5>
                            </Col>
                            <Col xs={8} sm={8} md={8} lg={8} style={{ padding: 0 }}>
                                <FormGroup>
                                    <InputGroup>
                                        <InputGroup.Addon style={{ cursor: 'pointer' }} onClick={() => { this.onDecreaseAmount(product_id) }}>-</InputGroup.Addon>
                                        <input className="form-control" value={product_amount}
                                            onChange={e => this.onAmountChange(e.target.value, product_id)} placeholder={'จำนวน'} type='number'
                                            onBlur={() => {
                                                product_amount == '' || product_amount == 0 ?
                                                    this.props.setOrderReviewPageState({ showModal: true, product_name: product_name, product_id: product_id })
                                                    : ''
                                            }}
                                        />
                                        <InputGroup.Addon style={{ cursor: 'pointer' }} onClick={() => { this.onIncreaseAmount(product_id) }}>+</InputGroup.Addon>
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col xs={4} sm={4} md={4} lg={4} style={{ padding: 0 }}>
                                <h5 style={{ textAlign: 'center' }}>{product_unit}</h5>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={12} style={{ padding: 0, paddingBottom: 10 }}>
                                <textarea style={{ width: '100%' }} placeholder='กรอกความต้องการเพิ่มเติม เช่น ขอดเกล็ดปลา'
                                    onChange={e => this.onProductDescriptionChange(e.target.value, product_id)}
                                    value={product_description} rows='3' />
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={12} style={{ padding: 0 }}>
                                <Col xs={8} sm={8} md={8} lg={8} style={{ padding: 0 }}>
                                    <h5 style={{ textAlign: 'center', display: 'inline-block' }}>ราคารวม&nbsp;</h5> <h4 style={{ color: '#384677', display: 'inline-block' }}><strong>{getMoneyFormat(product_price.toFixed(2))}</strong></h4><h5 style={{ display: 'inline-block' }}>&nbsp;บาท</h5>

                                </Col>
                                <Col xs={4} sm={4} md={4} lg={4} style={{ padding: 0 }}>
                                    <Button bsStyle='danger' className='pull-right' onClick={() => {
                                        let newState = { showModal: true, product_name: product_name, product_id: product_id }
                                        this.props.setOrderReviewPageState({ ...newState })
                                    }}>ลบ</Button>
                                </Col>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Panel>
        )
    }
}

export default connect(null, { updateCartProducts })(OrderReviewProductCard)


// WEBPACK FOOTER //
// ./src/components/order_review_product_card.js